var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefaultProperty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 75,
    viewBox: "0 0 101 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96 0H5C2.23858 0 0 2.23858 0 5V70C0 72.7614 2.23857 75 5 75H96C98.7614 75 101 72.7614 101 70V5C101 2.23858 98.7614 0 96 0Z",
    fill: "#D1DFE8",
    fillOpacity: 0.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.6191 33.5827H85.8606C85.7567 33.1382 85.1591 31.5971 82.197 32.1898C82.6907 31.686 83.0025 30.9451 82.8726 30.2338C82.8206 30.0263 82.7427 29.8189 82.6128 29.6411C82.4828 29.4929 82.3269 29.404 82.171 29.3447C81.0018 28.8705 78.9492 30.708 78.9492 30.708C81.4695 26.2032 74.61 24.3064 74.558 30.0263C74.558 30.0263 73.5447 27.9814 72.4534 28.5445C72.0117 28.8409 72.2715 29.7003 72.4794 30.0856C69.2575 28.3074 66.3474 29.404 67.6985 31.4193C64.5285 31.4785 63.6191 33.5827 63.6191 33.5827Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1895 22.7653H34.6487C34.5967 22.4985 34.2329 21.5798 32.4401 21.9354C32.7259 21.6391 32.9338 21.1945 32.8558 20.75C32.8299 20.6314 32.7779 20.4832 32.6999 20.3943C32.622 20.3054 32.5181 20.2461 32.4401 20.2165C31.7386 19.9201 30.4914 21.0463 30.4914 21.0463C32.0244 18.3197 27.8671 17.1639 27.8411 20.6314C27.8411 20.6314 27.2435 19.3867 26.5679 19.7423C26.3081 19.9201 26.464 20.4536 26.5939 20.6907C24.6452 19.6238 22.8784 20.2758 23.7098 21.4909C21.7351 21.5205 21.1895 22.7653 21.1895 22.7653Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6283 19.3024C62.5822 18.2145 62.5822 16.4506 61.6283 15.3626C60.6745 14.2747 59.1281 14.2747 58.1743 15.3626C57.2205 16.4506 57.2205 18.2145 58.1743 19.3024C59.1281 20.3903 60.6745 20.3903 61.6283 19.3024Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4656 27.5664H26.6201V35.7165H30.4656V27.5664Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6201 29.6113V30.4115L30.4656 29.9077V29.6113H26.6201Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9072 28.6335H26.1523V29.6116H30.9072V28.6335Z",
    fill: "#133B53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3633 61.0855H90.1729C89.991 60.4335 89.5233 59.9 89.0037 59.663C88.4321 59.3962 87.8085 59.4555 87.2109 59.6333C87.3148 59.6037 87.4707 59.3666 87.5486 59.2777C87.7305 59.0406 87.8864 58.8035 87.9124 58.5071C87.9644 58.1515 87.8604 57.7958 87.6785 57.5291C87.3668 57.0846 86.8211 56.9067 86.3274 56.966C86.3015 56.966 86.2755 56.966 86.2495 56.966C86.1455 56.9957 86.0676 56.9956 85.9637 57.0549C85.5739 57.2327 85.2102 57.5291 84.9244 57.8848C84.8724 57.944 84.8204 58.0033 84.7685 58.0922C84.7685 58.0922 85.5999 57.292 85.8078 56.6993C86.5353 54.9804 85.0023 52.5205 83.1055 53.2318C82.352 53.5874 81.7284 54.358 81.3127 55.2471C82.8457 52.639 80.2994 51.0683 79.4159 53.4096C79.9616 51.4832 79.1561 49.4679 77.4672 50.5941C77.4412 50.5941 77.4152 50.6237 77.3893 50.6237V61.0855H77.3633Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3633 61.0856H84.9243C84.8204 60.7003 84.5346 60.3743 84.2228 60.2558C83.885 60.1076 83.5213 60.1372 83.1575 60.2558C83.3394 59.8705 83.1055 59.337 82.7678 59.1889C82.43 59.0407 82.0402 59.1592 81.7284 59.3667C82.0142 59.2185 82.2221 58.8925 82.326 58.5369C82.7418 57.5292 81.8583 56.077 80.7411 56.4919C80.2994 56.6994 79.9356 57.1439 79.6758 57.6774C80.5852 56.1363 79.0782 55.2175 78.5585 56.5808C79.0782 55.0694 78.0908 54.1803 77.3633 54.5359V61.0856Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.1841 52.8468C84.9762 53.0542 84.6904 53.0246 84.6904 53.0246C84.6904 53.0246 84.7164 52.669 84.9243 52.4615C85.1321 52.2541 85.418 52.2837 85.418 52.2837C85.418 52.2837 85.392 52.6393 85.1841 52.8468Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.3641 55.2767C79.2082 55.5731 78.8964 55.6916 78.8964 55.6916C78.8964 55.6916 78.8185 55.2767 78.9744 54.9803C79.1303 54.684 79.4421 54.5654 79.4421 54.5654C79.4421 54.5654 79.52 54.9507 79.3641 55.2767Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5869 52.0462C84.6649 52.4908 84.483 52.9353 84.483 52.9353C84.483 52.9353 84.1452 52.6686 84.0673 52.2241C83.9893 51.7795 84.1712 51.335 84.1712 51.335C84.1712 51.335 84.483 51.6017 84.5869 52.0462Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2517 61.0558L16.4336 57.7957L14.8486 55.7212L14.9526 55.6323L15.888 56.5214L16.0179 55.6323L16.1738 55.6619L16.1478 56.7881L16.5375 57.2326L16.6674 53.8837L15.888 52.7871L15.9919 52.7279L16.7974 53.4391L16.8493 51.7202H17.0572L17.1871 53.8541L17.395 55.9879L18.4343 54.6839L18.5382 54.7432L18.1485 55.4248H18.824V55.5434L18.0965 55.6915L17.369 56.9659L17.5249 61.0558H16.2517Z",
    fill: "#133B53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9828 49.2603C22.9828 48.8454 22.9568 48.4305 22.8269 48.0748C22.671 47.7192 22.3852 47.3932 22.0214 47.3339C21.8136 47.3043 21.5797 47.3636 21.4758 47.5414C21.8655 46.9783 22.2293 46.3559 22.3852 45.6446C22.5411 44.9333 22.4631 44.1332 22.0474 43.5997C21.6577 43.0662 21.0081 42.8291 20.3845 42.9477C19.7869 43.0366 19.2412 43.4515 18.8255 43.985C18.8775 42.8884 19.0853 41.7919 18.9035 40.7249C18.7216 39.658 17.994 38.5911 17.0327 38.6207C16.3831 38.6504 15.8375 39.1838 15.4217 39.7469C14.5643 40.9324 14.0446 42.4142 13.9407 43.9553C13.6809 43.5701 13.447 43.1848 13.1092 42.8884C12.7715 42.592 12.3557 42.3846 11.94 42.4735C11.2644 42.592 10.8227 43.3922 10.6408 44.1628C10.459 44.9926 10.4849 45.8521 10.7188 46.6523C11.0826 47.9859 11.966 49.0529 12.8234 50.0309C12.4337 49.8234 11.94 50.0901 11.7581 50.5347C11.4983 51.1274 11.7581 51.8091 12.0959 52.2833C12.4077 52.6685 12.7974 52.9649 13.2132 53.202C15.4997 54.506 18.3058 54.3282 20.6183 53.1724C21.4758 52.7574 22.0734 52.0462 22.5411 51.0978C22.8529 50.5643 22.9828 49.9123 22.9828 49.2603Z",
    fill: "#133B53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6022 54.8023C15.4983 54.6542 15.1865 54.5949 15.1865 54.8616C15.0826 54.0614 14.1732 54.3578 14.6149 55.1283C13.9133 54.2985 13.2898 55.3654 14.1992 55.8396C13.4197 55.8693 13.8614 57.114 14.5369 56.5805C14.2511 56.7584 14.433 57.1733 14.7448 57.1436C15.5243 56.9658 16.3298 55.5433 15.6022 54.8023Z",
    fill: "#133B53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2258 52.4314C14.1739 52.224 14.1219 51.9869 14.1479 51.7794C14.1739 51.5423 14.2778 51.3349 14.4597 51.246C14.5636 51.1867 14.6935 51.1867 14.7975 51.246C14.5117 51.0089 14.2258 50.7421 14.044 50.4161C13.8621 50.0605 13.7841 49.6456 13.94 49.2603C14.0699 48.9047 14.3817 48.6676 14.7195 48.6083C15.0573 48.549 15.3951 48.6676 15.6809 48.875C15.499 48.3119 15.2392 47.7488 15.1872 47.1561C15.1353 46.5634 15.3691 45.8521 15.8888 45.7039C16.2265 45.615 16.5903 45.7928 16.9021 46.0003C17.5257 46.4744 18.0194 47.1561 18.2792 47.9563C18.3572 47.6896 18.4351 47.4525 18.565 47.2154C18.6949 47.0079 18.9028 46.8301 19.1366 46.7708C19.5264 46.7115 19.8642 47.0672 20.0461 47.4228C20.2539 47.8377 20.3579 48.3119 20.3579 48.7565C20.3579 49.527 20.0201 50.2383 19.7083 50.9496C19.8902 50.7718 20.176 50.831 20.3579 51.0089C20.5657 51.2756 20.5397 51.6905 20.4098 51.9869C20.3059 52.2536 20.124 52.4907 19.9421 52.6685C18.9028 53.7947 17.3958 54.2096 15.9927 54.0022C15.473 53.9429 15.0573 53.6762 14.6935 53.2613C14.4857 53.0834 14.3298 52.7871 14.2258 52.4314Z",
    fill: "#133B53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6274 49.7046C11.7573 49.9713 11.6794 50.327 11.6794 50.327C11.6794 50.327 11.3935 50.2084 11.2636 49.9417C11.1337 49.675 11.2117 49.3193 11.2117 49.3193C11.2117 49.3193 11.4975 49.4379 11.6274 49.7046Z",
    fill: "#133B53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8224 50.2978C11.1862 50.2682 11.524 50.5942 11.524 50.5942C11.524 50.5942 11.2382 50.9498 10.8744 50.9794C10.5106 51.0091 10.1729 50.6831 10.1729 50.6831C10.1729 50.6831 10.4587 50.2978 10.8224 50.2978Z",
    fill: "#133B53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0585 55.8101C18.9285 55.7508 18.8506 55.573 18.8506 55.573C18.8506 55.573 19.0065 55.5137 19.1364 55.573C19.2663 55.6322 19.3443 55.8101 19.3443 55.8101C19.3443 55.8101 19.1884 55.8693 19.0585 55.8101Z",
    fill: "#133B53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2143 55.2765C19.0584 55.4247 18.8506 55.4247 18.8506 55.4247C18.8506 55.4247 18.8766 55.1579 19.0065 55.0098C19.1624 54.8616 19.3702 54.8616 19.3702 54.8616C19.3702 54.8616 19.3702 55.1283 19.2143 55.2765Z",
    fill: "#133B53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0327 46.2967C18.8509 46.5338 18.5391 46.5338 18.5391 46.5338C18.5391 46.5338 18.5391 46.1782 18.7209 45.9707C18.9028 45.7336 19.2146 45.7336 19.2146 45.7336C19.2146 45.7336 19.2146 46.0893 19.0327 46.2967Z",
    fill: "#133B53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4077 48.0748C14.5896 48.1637 14.6675 48.3712 14.6675 48.3712C14.6675 48.3712 14.4597 48.4601 14.3038 48.4008C14.1219 48.3119 14.0439 48.1045 14.0439 48.1045C14.0439 48.1045 14.2258 48.0155 14.4077 48.0748Z",
    fill: "#133B53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3053 45.6153C18.4353 46.0302 18.2794 46.4451 18.2794 46.4451C18.2794 46.4451 17.8896 46.2377 17.7597 45.8228C17.6298 45.4078 17.7857 44.9929 17.7857 44.9929C17.7857 44.9929 18.1754 45.2004 18.3053 45.6153Z",
    fill: "#133B53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1627 56.6402C15.0847 56.6402 15.0328 56.6402 14.9548 56.6402C14.8509 56.6402 14.7729 56.5809 14.695 56.492C14.643 56.4327 14.617 56.3142 14.643 56.2252C14.695 56.1067 14.8249 56.1363 14.9028 56.0178C14.9288 55.9585 14.9288 55.8992 14.9288 55.8103C14.9288 55.7511 14.9028 55.6621 14.9288 55.6029C14.9548 55.5436 15.0068 55.4843 15.0587 55.4843C15.1107 55.4843 15.1367 55.5436 15.1627 55.5732C15.1887 55.6029 15.2146 55.6029 15.2406 55.6029C15.3445 55.6029 15.3705 55.425 15.5004 55.425C15.6304 55.4547 15.6823 55.6029 15.7343 55.7214C15.7863 55.9289 15.7603 56.166 15.6304 56.3438C15.5004 56.5512 15.3186 56.6105 15.1627 56.6402Z",
    fill: "#133B53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1137 24.9585L36.8315 24.425L21.0078 41.7625H33.1679H67.2836H79.4177L64.1137 24.9585Z",
    fill: "#133B53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0661 41.7622H60.3457V59.8406H78.0661V41.7622Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0659 41.7622H76.1172V59.8406H78.0659V41.7622Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2944 41.7622H60.3457V59.8406H62.2944V41.7622Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1175 44.4001H62.2686V44.6372H76.1175V44.4001Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1175 46.9487H62.2686V47.1858H76.1175V46.9487Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1175 49.4976H62.2686V49.7346H76.1175V49.4976Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1175 52.0461H62.2686V52.2832H76.1175V52.0461Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1175 54.595H62.2686V54.8321H76.1175V54.595Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1175 57.1143H62.2686V57.3513H76.1175V57.1143Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2944 44.3999H60.3457V44.637H62.2944V44.3999Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2944 46.9487H60.3457V47.1858H62.2944V46.9487Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2944 49.4976H60.3457V49.7346H62.2944V49.4976Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2944 52.0459H60.3457V52.283H62.2944V52.0459Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2944 54.5947H60.3457V54.8318H62.2944V54.5947Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2944 57.114H60.3457V57.3511H62.2944V57.114Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0659 44.4001H76.1172V44.6372H78.0659V44.4001Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0659 46.9487H76.1172V47.1858H78.0659V46.9487Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0659 49.4976H76.1172V49.7346H78.0659V49.4976Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0659 52.0461H76.1172V52.2832H78.0659V52.0461Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0659 54.595H76.1172V54.8321H78.0659V54.595Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0659 57.1143H76.1172V57.3513H78.0659V57.1143Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0798 41.7622H22.3594V59.8406H40.0798V41.7622Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9239 44.3999H22.3594V44.637H39.9239V44.3999Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9239 46.9487H22.3594V47.1858H39.9239V46.9487Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9239 49.4976H22.3594V49.7346H39.9239V49.4976Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9239 52.0459H22.3594V52.283H39.9239V52.0459Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9239 54.5947H22.3594V54.8318H39.9239V54.5947Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9239 57.114H22.3594V57.3511H39.9239V57.114Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0658 45.4966H25.3994V59.8704H37.0658V45.4966Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0658 46.119L25.3994 48.2824V45.4966H37.0658V46.119Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1057 59.8703H39.3262L39.7939 41.7622H40.1057V59.8703Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1058 42.0586L22.3594 43.1848V41.7622H40.1058V42.0586Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2676 41.7622V43.0662L76.1166 42.1771V41.7622H62.2676Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1172 41.7622V42.1771L78.0659 42.0586V41.7622H76.1172Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3457 41.7622V43.1848L62.2684 43.0662V41.7622H60.3457Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3463 59.8707H40.1055V31.7454L50.2129 22.7358L60.3463 31.7454V59.8707Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2129 22.7358L40.1055 31.7454V33.7903L49.7452 25.255L60.3463 34.7091V31.7454L50.2129 22.7358Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9568 31.9824L50.2125 21.9355L38.4941 32.0713L39.6374 33.3753L50.2125 23.9805L60.7616 33.3457L61.9568 31.9824Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6394 59.8704H21.2168V61.1151H78.6394V59.8704Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1426 48.6082H27.3477V59.8701H35.1426V48.6082Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.959 49.1121H27.9189V59.2182H30.959V49.1121Z",
    fill: "#133B53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5449 49.1121H31.5049V59.2182H34.5449V49.1121Z",
    fill: "#133B53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1426 48.4304H27.3477H27.2698H27.1918L27.0879 59.8702H27.3477V48.6082H35.1426V48.4304Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7415 48.6082H63.5947V56.2544H74.7415V48.6082Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.986 49.1121H64.1152V55.6618H65.986V49.1121Z",
    fill: "#133B53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8568 49.1121H66.5303V55.6618H71.8568V49.1121Z",
    fill: "#133B53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2731 49.1121H72.4023V55.6618H74.2731V49.1121Z",
    fill: "#133B53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7411 48.4897H63.5944H63.4385L63.3086 56.2546H63.5944V48.6083H74.7411V48.4897Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5944 56.1953H74.7411V56.3731L63.3086 56.9066V56.1953H63.5944Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3408 49.1123H43.3008V59.2184H46.3408V49.1123Z",
    fill: "#133B53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9521 49.1123H46.9121V59.2184H49.9521V49.1123Z",
    fill: "#133B53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5371 49.1123H50.4971V59.2184H53.5371V49.1123Z",
    fill: "#133B53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.124 49.1123H54.084V59.2184H57.124V49.1123Z",
    fill: "#133B53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.487 48.4897H42.5727L42.3389 59.8703H42.8066V48.6083H57.487V48.4897Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9521 31.9226H46.9121V42.0287H49.9521V31.9226Z",
    fill: "#133B53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.539 31.9226H50.499V42.0287H53.539V31.9226Z",
    fill: "#133B53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0319 31.3005H46.185L45.9512 42.6514H46.4189V31.3894H54.0319V31.3005Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1884 42.592H42.2607V43.5108H58.1884V42.592Z",
    fill: "#133B53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1889 43.5108H42.2613V42.592L41.6377 43.5108V44.3999L58.1889 43.7182V43.5108Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2227 40.0432H42.9629V42.592H43.2227V40.0432Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8497 40.0432H51.5898V42.592H51.8497V40.0432Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9649 40.0432H48.7051V42.592H48.9649V40.0432Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7071 40.0432H54.4473V42.592H54.7071V40.0432Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0811 40.0432H45.8213V42.592H46.0811V40.0432Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5909 40.0432H57.3311V42.592H57.5909V40.0432Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2227 40.0432H42.9629V40.2803H43.2227V40.0432Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8497 40.0432H51.5898V40.2803H51.8497V40.0432Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9649 40.0432H48.7051V40.2803H48.9649V40.0432Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7071 40.0432H54.4473V40.2803H54.7071V40.0432Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0811 40.0432H45.8213V40.2803H46.0811V40.0432Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5909 40.0432H57.3311V40.2803H57.5909V40.0432Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8257 40.0431H42.5996V39.3911L57.8257 39.5393V40.0431Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9696 58.5376H13.1094V58.9229H21.9696V58.5376Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9696 60.1084H13.1094V60.4937H21.9696V60.1084Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0447 61.0568H13.4471C13.4211 61.0568 13.3691 61.0271 13.3691 60.9975V58.0635C13.3691 58.0338 13.3691 58.0338 13.3951 58.0338L13.7069 57.6189C13.7329 57.5893 13.7849 57.5893 13.8109 57.6189L14.1226 58.0338L14.1486 58.0635V60.9975C14.0967 61.0271 14.0707 61.0568 14.0447 61.0568Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2927 61.0568H14.6951C14.6692 61.0568 14.6172 61.0271 14.6172 60.9975V58.0635C14.6172 58.0338 14.6172 58.0338 14.6432 58.0338L14.955 57.6189C14.981 57.5893 15.0329 57.5893 15.0589 57.6189L15.3707 58.0338L15.3967 58.0635V60.9975C15.3707 61.0271 15.3447 61.0568 15.2927 61.0568Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5388 61.0568H15.9412C15.9152 61.0568 15.8633 61.0271 15.8633 60.9975V58.0635C15.8633 58.0338 15.8633 58.0338 15.8893 58.0338L16.2011 57.6189C16.227 57.5893 16.279 57.5893 16.305 57.6189L16.6168 58.0338L16.6428 58.0635V60.9975C16.6168 61.0271 16.5908 61.0568 16.5388 61.0568Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8123 61.0568H17.2147C17.1887 61.0568 17.1367 61.0271 17.1367 60.9975V58.0635C17.1367 58.0338 17.1367 58.0338 17.1627 58.0338L17.4745 57.6189C17.5005 57.5893 17.5524 57.5893 17.5784 57.6189L17.8902 58.0338L17.9162 58.0635V60.9975C17.8642 61.0271 17.8383 61.0568 17.8123 61.0568Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0593 61.0568H18.4617C18.4358 61.0568 18.3838 61.0271 18.3838 60.9975V58.0635C18.3838 58.0338 18.3838 58.0338 18.4098 58.0338L18.7216 57.6189C18.7476 57.5893 18.7995 57.5893 18.8255 57.6189L19.1373 58.0338L19.1633 58.0635V60.9975C19.1373 61.0271 19.0853 61.0568 19.0593 61.0568Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3064 61.0568H19.7088C19.6828 61.0568 19.6309 61.0271 19.6309 60.9975V58.0635C19.6309 58.0338 19.6309 58.0338 19.6568 58.0338L19.9686 57.6189C19.9946 57.5893 20.0466 57.5893 20.0726 57.6189L20.3844 58.0338L20.4104 58.0635V60.9975C20.3844 61.0271 20.3584 61.0568 20.3064 61.0568Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5799 61.0568H20.9822C20.9563 61.0568 20.9043 61.0271 20.9043 60.9975V58.0635C20.9043 58.0338 20.9043 58.0338 20.9303 58.0338L21.2421 57.6189C21.2681 57.5893 21.32 57.5893 21.346 57.6189L21.6578 58.0338L21.6838 58.0635V60.9975C21.6318 61.0271 21.6058 61.0568 21.5799 61.0568Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2656 58.5374H76.7158V58.9226H89.2656V58.5374Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2656 60.1082H76.7158V60.4934H89.2656V60.1082Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6765 61.0568H77.0789C77.0529 61.0568 77.001 61.0271 77.001 60.9975V58.0635C77.001 58.0338 77.001 58.0338 77.027 58.0338L77.3388 57.6189C77.3647 57.5893 77.4167 57.5893 77.4427 57.6189L77.7545 58.0338L77.7805 58.0635V60.9975C77.7285 61.0271 77.7025 61.0568 77.6765 61.0568Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9246 61.0568H78.327C78.301 61.0568 78.249 61.0271 78.249 60.9975V58.0635C78.249 58.0338 78.249 58.0338 78.275 58.0338L78.5868 57.6189C78.6128 57.5893 78.6648 57.5893 78.6907 57.6189L79.0025 58.0338L79.0285 58.0635V60.9975C78.9766 61.0271 78.9506 61.0568 78.9246 61.0568Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1707 61.0568H79.5731C79.5471 61.0568 79.4951 61.0271 79.4951 60.9975V58.0635C79.4951 58.0338 79.4951 58.0338 79.5211 58.0338L79.8329 57.6189C79.8589 57.5893 79.9109 57.5893 79.9368 57.6189L80.2486 58.0338L80.2746 58.0635V60.9975C80.2486 61.0271 80.2226 61.0568 80.1707 61.0568Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4187 61.0568H80.8211C80.7951 61.0568 80.7432 61.0271 80.7432 60.9975V58.0635C80.7432 58.0338 80.7432 58.0338 80.7691 58.0338L81.0809 57.6189C81.1069 57.5893 81.1589 57.5893 81.1849 57.6189L81.4967 58.0338L81.5227 58.0635V60.9975C81.4967 61.0271 81.4707 61.0568 81.4187 61.0568Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.6912 61.0568H82.0936C82.0676 61.0568 82.0156 61.0271 82.0156 60.9975V58.0635C82.0156 58.0338 82.0156 58.0338 82.0416 58.0338L82.3534 57.6189C82.3794 57.5893 82.4314 57.5893 82.4573 57.6189L82.7691 58.0338L82.7951 58.0635V60.9975C82.7431 61.0271 82.7172 61.0568 82.6912 61.0568Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9383 61.0568H83.3406C83.3147 61.0568 83.2627 61.0271 83.2627 60.9975V58.0635C83.2627 58.0338 83.2627 58.0338 83.2887 58.0338L83.6005 57.6189C83.6265 57.5893 83.6784 57.5893 83.7044 57.6189L84.0162 58.0338L84.0422 58.0635V60.9975C84.0162 61.0271 83.9642 61.0568 83.9383 61.0568Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.1853 61.0568H84.5877C84.5617 61.0568 84.5098 61.0271 84.5098 60.9975V58.0635C84.5098 58.0338 84.5098 58.0338 84.5358 58.0338L84.8475 57.6189C84.8735 57.5893 84.9255 57.5893 84.9515 57.6189L85.2633 58.0338L85.2893 58.0635V60.9975C85.2633 61.0271 85.2373 61.0568 85.1853 61.0568Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.4588 61.0568H85.8611C85.8352 61.0568 85.7832 61.0271 85.7832 60.9975V58.0635C85.7832 58.0338 85.7832 58.0338 85.8092 58.0338L86.121 57.6189C86.147 57.5893 86.1989 57.5893 86.2249 57.6189L86.5367 58.0338L86.5627 58.0635V60.9975C86.5107 61.0271 86.4847 61.0568 86.4588 61.0568Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7058 61.0568H87.1082C87.0822 61.0568 87.0303 61.0271 87.0303 60.9975V58.0635C87.0303 58.0338 87.0303 58.0338 87.0563 58.0338L87.3681 57.6189C87.394 57.5893 87.446 57.5893 87.472 57.6189L87.7838 58.0338L87.8098 58.0635V60.9975C87.7578 61.0271 87.7318 61.0568 87.7058 61.0568Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9529 61.0568H88.3553C88.3293 61.0568 88.2773 61.0271 88.2773 60.9975V58.0635C88.2773 58.0338 88.2773 58.0338 88.3033 58.0338L88.6151 57.6189C88.6411 57.5893 88.6931 57.5893 88.719 57.6189L89.0308 58.0338L89.0568 58.0635V60.9975C89.0308 61.0271 88.9789 61.0568 88.9529 61.0568Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4864 60.9373H12.2773V61.2336H90.4864V60.9373Z",
    fill: "#133B53"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultProperty);
export default __webpack_public_path__ + "static/media/defaultProperty.a4c94df6f679125a834f953bd53e5d57.svg";
export { ForwardRef as ReactComponent };